import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  input[type=\"checkbox\"] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    span {\n      border-radius: 50%;\n      width: 46px;\n      height: 46px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      .color-checkbox__icon {\n        &-check,\n        &-cross {\n          display: none;\n        }\n      }\n    }\n\n    ", ":hover & {\n      span {\n        border: 4px solid rgba(255, 255, 255, 0.3);\n      }\n    }\n\n    :focus {\n      outline: none;\n    }\n  }\n\n  input:checked + div {\n    span {\n      border: 4px solid rgba(255, 255, 255, 0.3);\n      .color-checkbox__icon {\n        &-check {\n          display: block;\n        }\n      }\n    }\n    &:hover {\n      span {\n        .color-checkbox__icon {\n          &-check {\n            display: none;\n          }\n          &-cross {\n            display: block;\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  margin: 3px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from "@styles";
export var ColorCheckbox = styled.div(_templateObject());
export var Label = styled.label(_templateObject2(), ColorCheckbox);